import React, { memo } from "react";
import { ComposableMap, Geographies, Geography, ZoomableGroup } from "react-simple-maps";
import { GEO_URL, getGeoName } from "./constants";
import CountryMarker from "./CountryMarker";

const WorldMapBase = memo(function WorldMapBase({
  zoom,
  center,
  focusedCountry,
  countries,
  countryDotClouds,
  stateDotClouds,
  onCountryHover,
}) {
  return (
    <ComposableMap
      projection="geoMercator"
      projectionConfig={{ scale: 140, center: [15, 15] }}
      style={{ width: "100%", height: "auto" }}
      viewBox="0 0 800 450"
    >
      <ZoomableGroup
        zoom={zoom}
        center={center}
        minZoom={1}
        maxZoom={14}
        onMoveEnd={() => {}}
      >
        {/* Countries */}
        <Geographies geography={GEO_URL}>
          {({ geographies }) =>
            geographies.map((geo) => {
              const isFocused =
                focusedCountry &&
                geo.properties?.name === getGeoName(focusedCountry.countryCode);
              return (
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  fill={isFocused ? "#252950" : "#1E2035"}
                  stroke={isFocused ? "#E5B978" : "#2A2D4A"}
                  strokeWidth={isFocused ? 1 : 0.5}
                  style={{
                    default: { outline: "none" },
                    hover: { fill: "#252845", outline: "none" },
                    pressed: { outline: "none" },
                  }}
                />
              );
            })
          }
        </Geographies>

        {/* Country markers with dots */}
        {countries.map((country, ci) => {
          const cloud = countryDotClouds[ci];
          const isFocused = focusedCountry?.countryCode === country.countryCode;
          const stateCloud = stateDotClouds.find(
            (sc) => sc.countryCode === country.countryCode
          );

          return (
            <CountryMarker
              key={country.countryCode}
              country={country}
              countryDots={cloud.dots}
              stateDotCloud={stateCloud}
              isFocused={isFocused}
              onHover={onCountryHover}
            />
          );
        })}
      </ZoomableGroup>
    </ComposableMap>
  );
});

export default WorldMapBase;
